import { lazy, Suspense, useMemo } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { DHSCheckEligibilityLoading } from "./DHSCheckEligibility.loading";
import { DHSCheckEligibilityProps } from "./DHSCheckEligibility.types";
import { addTranslationResources } from "./DHSCheckEligibility.translations";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useFeatureFlag } from "../FeatureFlag/FeatureFlagsProvider";

export const DHSCheckEligibilityLoadable = lazy(
  () => import("./DHSCheckEligibility")
);

type WrapperProps = Omit<DHSCheckEligibilityProps, "i18next" | "useTranslation"> & {
  i18next?: typeof i18next
};

export const DHSCheckEligibilityWrapper = (props: WrapperProps) => {
  const useTranslationFn = useTranslation;
  const i18nInstance = props.i18next || i18next;
  const dhsEnabled = useFeatureFlag("FEATURE_DHS_INTEGRATION");
  const { user } = props;

  useMemo(() => {
    addTranslationResources(i18nInstance);
  }, [i18nInstance]);

  if (!dhsEnabled || !user?.permissions?.checkDhsEligibility) return null;

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<DHSCheckEligibilityLoading />}>
        <DHSCheckEligibilityLoadable
          {...(props as DHSCheckEligibilityProps)}
          i18next={i18nInstance}
          useTranslation={useTranslationFn}
        />
      </Suspense>
    </ErrorBoundary>
  );
};

export { DHSCheckEligibilityWrapper as DHSCheckEligibility };
